import { largeTabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import Link from 'next/link';
import styled from 'styled-components';

export const LogOutLinkButton = styled.button`
  background: none;
  border: none;
  padding: 16px;
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: right;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.textDark};

  &:hover {
    color: ${(props) => props.theme.primary};
  }
`;

export const UserLinkBox = styled(Link)<{ $active?: boolean }>`
  padding: 16px;
  cursor: pointer;
  display: block;
  width: 100%;
  text-align: right;
  font-weight: bold;
  white-space: nowrap;
  color: ${({ theme }) => theme.textDark};

  &:hover {
    color: ${(props) => props.theme.primary};
  }

  ${(props) =>
    props.$active &&
    `
    background-color: ${props.theme.darkGreyTranslucent};

    & + ul {
      display: block;
    }
  `}
`;

export const UserSubMenuBox = styled.ul<{ $loggedIn: boolean }>`
  display: flex;
  flex-direction: column;
  position: absolute;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: ${(props) => (props.$loggedIn ? '200' : '100')}px;
  background-color: ${(props) => props.theme.white};
  z-index: 60;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  right: 20px;
  top: 58px;

  li {
    padding-left: 20px;
  }

  @media (${largeTabletMax}) {
    right: 10px;
  }

  &:after {
    content: '';
    width: 10px;
    height: 10px;
    transform: rotate(45deg);
    background: ${(props) => props.theme.white};
    position: absolute;
    top: -5px;
    right: 20px;
  }
`;

export const HeaderIcon = styled.div`
  justify-content: center;
  display: inline-flex;
`;

export const HeaderButton = styled.button<{ $active?: boolean }>`
  position: relative;
  background: none;
  list-style: none;
  padding: 0 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  text-align: center;
  gap: 5px;
  border: 1px solid ${({ theme }) => theme.white};
  border-radius: 30px;
  height: 44px;

  p {
    white-space: nowrap;
    margin-top: 2px;
    font-size: 14px;
  }

  ${(props) =>
    props.$active &&
    `
    & + ul {
      display: flex;
      flex-direction: column;
    } 
  `}
`;
